import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "./core/Auth";
import { setRegionIdMe } from "sr/helpers/functions/setCityMe";

export default function Impersonate() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { persistToken } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get("token");
    const refreshToken = searchParams.get("refreshToken");
    const userType = searchParams.get("userType");
    const userId = searchParams.get("userId");

    if (!token || !refreshToken || !userType || !userId) {
      setError("Missing required parameters for impersonation.");
      return;
    }

    document.cookie = `refreshToken=${refreshToken}`;
    localStorage.setItem("auth", JSON.stringify({ userType, user_id: userId }));
    setRegionIdMe(null);
    persistToken(token);

    switch (userType) {
      case "company":
        navigate("/jobs-listing", { replace: true });
        break;
      case "cleaner":
        navigate("/cleaner-jobs", { replace: true });
        break;
      case "individual":
        navigate("/individual/jobs", { replace: true });
        break;
      case "supervisor":
        navigate("/supervisor/work-order", { replace: true });
        break;
      case "corporate":
        navigate("/corporate/requirement-listing", { replace: true });
        break;
      default:
        navigate("/", { replace: true });
    }
  }, []);

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center p-6 bg-red-50 border border-red-200 rounded-lg max-w-md">
          <h2 className="text-lg font-semibold text-red-800 mb-2">
            Impersonation Error
          </h2>
          <p className="text-red-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" />
        <p className="text-gray-600">Setting up session...</p>
      </div>
    </div>
  );
}
